import { fetchPostByLink, fetchPosts, fetchFeaturedPost } from "./queries";

const getPostByLink = async (data) => {
  const result = await fetchPostByLink(data);

  if (result.message) {
    return { success: false, message: result.message };
  }

  return { ...result, success: true };
};

const getPosts = async (data) => {
  const result = await fetchPosts(data);

  if (result.message) {
    return { success: false, message: result.message };
  }

  return { ...result, success: true };
};

const getFeaturedPost = async () => {
  const result = await fetchFeaturedPost();

  if (result.message) {
    return { success: false, message: result.message };
  }

  return { ...result, success: true };
};

export { getPostByLink, getPosts, getFeaturedPost };
